export default __webpack_public_path__ + "static/media/arrow_6.0dee9179.svg";